<!--
 * @Description: 
 * @Date: 2021-02-04 19:55:30
-->
<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import player from './player';
import pcPlayer from './pc-player';
import before from './before';
import end from './end';

// 直播状态对应组件名
const componentMap = {
  1: 'before',
  2: 'player',
  3: 'end',
  4: 'end',
  5: 'player'
};
export default {
  name: 'LivingVideo',
  inject: ['livingStore'],
  data() {
    return {
      componentName: ''
    };
  },
  components: { pcPlayer, player, end, before },
  watch: {
    livingStatus() {}
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    }),
    livingStatus() {
      let livingStatus = this.livingStore.livingStatus;
      this.componentName = componentMap[livingStatus]; // 根据当前直播状态渲染组件
      if (
        this.isDesktop &&
        livingStatus == 2 &&
        this.componentName == 'player'
      ) {
        this.componentName = 'pcPlayer';
      }
      return livingStatus;
    }
  },
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
